export default editor => {
    editor.DomComponents.addType('input', {
        // Make the editor understand when to bind `my-input-type`
        isComponent: el => {
            if (el.classList && el.classList.contains('et-input')) {
                return { type: 'input' }
            }
            return false
        },
        extend: 'default',
        // Model definition
        model: {
            // Default properties
            defaults: {
                tagName: 'input',
                name: 'Eingabefeld',
                draggable: '[data-gjs-type=column]',
                attributes: {
                    class: 'et-input',
                    placeholder: `Lorem ipsum dolor....`
                },
                highlightable: true,
                hoverable: true,
                traits:[
                    {
                        label: 'Platzhalter', // The label you will see in Settings
                        name: 'placeholder', // The name of the attribute/property to use on component
                    }
                ]
            }
        }
    });
}
